import React, { useLayoutEffect, useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { numberMasking } from '../utils/numberMasking';

const columns = [
    { key: 'phonenumber', label: 'Phone Number' },
    { key: 'campname', label: 'Campaign Name' },
    { key: 'callstatus', label: 'Call Status' },
    { key: 'callstartdate', label: 'Call Start Date' },
];

export default function CallResults({ data, loading, error, exportError, onRetry }) {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const isUnmatched = data?.kind === 'unmatched-calls';
    const visibleColumns = columns;
    useLayoutEffect(() => { setPage(1); }, [data]);
    const total = data?.total || 0;
    const pages = Math.max(1, Math.ceil(total / pageSize));
    const activePage = Math.min(page, pages);
    const start = (activePage - 1) * pageSize;
    const visibleRows = data?.rows.slice(start, start + pageSize) || [];
    return <section className="crm-call-results" aria-label={isUnmatched ? 'Unmatched call records' : 'Filtered call records'} aria-busy={loading}>
        <div className="crm-results-heading"><div><h2>{isUnmatched ? 'Unmatched Call Records' : 'Call Records'}</h2>{data && <span className="crm-results-total">{total.toLocaleString('en-IN')} total</span>}</div>
            {data && <span className="crm-results-showing">Showing <strong>{visibleRows.length}</strong> of <strong>{total.toLocaleString('en-IN')}</strong></span>}
        </div>
        {isUnmatched && data.matchRange && <p className="crm-report-notice">No CRM order found from {data.matchRange.startDate} to {data.matchRange.endDate}</p>}
        {exportError && <p className="crm-report-error" role="alert">{exportError}</p>}
        {error ? <div className="crm-report-error" role="alert">{error}<button type="button" onClick={onRetry}>Retry results</button></div> :
            loading ? <p className="crm-results-state" role="status">Loading call records...</p> :
                data && !data.rows.length ? <p className="crm-results-state">{isUnmatched ? 'No unmatched calls found. All call numbers have a CRM order in the last month.' : 'No calls found for these filters.'}</p> :
                    data && <div className="crm-results-scroll" tabIndex={0} role="region" aria-label="Call records table">
                        <table><thead><tr><th scope="col">#</th>{visibleColumns.map(column => <th key={column.key} scope="col">{column.label}</th>)}</tr></thead>
                            <tbody>{visibleRows.map((row, index) => <tr key={`${row.logid || ''}-${start + index}`}>
                                <td>{start + index + 1}</td>
                                {visibleColumns.map(column => <td key={column.key}>{row[column.key] == null ? '—' :
                                    ['phonenumber', 'order_mobile'].includes(column.key) ? <span className="crm-call-phone">{numberMasking(row[column.key])}</span> :
                                        column.key === 'callstatus' ? <span className={`crm-call-status${['CONNECTED', 'ANSWERED', 'COMPLETED'].includes(String(row[column.key]).toUpperCase()) ? ' crm-call-status-connected' : ''}`}>{String(row[column.key])}</span> :
                                            String(row[column.key])}</td>)}
                            </tr>)}</tbody>
                        </table>
                    </div>}
        {data && <div className="crm-results-pagination"><label>Rows per page <select aria-label="Rows per page" value={pageSize}
            disabled={loading} onChange={event => { setPageSize(Number(event.target.value)); setPage(1); }}>
            {[25, 50, 100].map(size => <option key={size} value={size}>{size}</option>)}</select></label>
            <span>Page {activePage} of {pages}</span><div>
                <button type="button" onClick={() => setPage(activePage - 1)} disabled={loading || activePage <= 1}><FiChevronLeft /> Previous</button>
                <button type="button" onClick={() => setPage(activePage + 1)} disabled={loading || activePage >= pages}>Next <FiChevronRight /></button>
            </div></div>}
    </section>;
}
